export interface FocusSession {
  taskId: string;
  durationMs: number;
  remainingMs: number;
  startedAt: number | null;
}

export function normalizeFocusSession(value: unknown): FocusSession | null {
  if (!value || typeof value !== "object") return null;
  const item = value as Partial<FocusSession>;
  if (typeof item.taskId !== "string" || !item.taskId || typeof item.durationMs !== "number" || !Number.isFinite(item.durationMs) || item.durationMs < 60_000 || item.durationMs > 4 * 60 * 60_000 || typeof item.remainingMs !== "number" || !Number.isFinite(item.remainingMs) || item.remainingMs < 0 || item.remainingMs > item.durationMs || item.startedAt !== null && (typeof item.startedAt !== "number" || !Number.isFinite(item.startedAt))) return null;
  return { taskId: item.taskId, durationMs: item.durationMs, remainingMs: item.remainingMs, startedAt: item.startedAt };
}

export function focusRemaining(session: FocusSession, now: number): number {
  return Math.max(0, session.remainingMs - (session.startedAt === null ? 0 : Math.max(0, now - session.startedAt)));
}

export function pauseFocus(session: FocusSession, now: number): FocusSession {
  return { ...session, remainingMs: focusRemaining(session, now), startedAt: null };
}

export function resumeFocus(session: FocusSession, now: number): FocusSession {
  return session.startedAt === null && session.remainingMs > 0 ? { ...session, startedAt: now } : session;
}

export function formatFocusTime(milliseconds: number): string {
  const seconds = Math.ceil(milliseconds / 1000);
  return `${String(Math.floor(seconds / 60)).padStart(2, "0")}:${String(seconds % 60).padStart(2, "0")}`;
}
